import { useEffect } from 'react';

export const useNoCache = () => {
  useEffect(() => {
    // Desregistrar cualquier Service Worker para desactivar PWA/caché agresiva
    if (navigator?.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((reg) => reg.unregister().catch(() => undefined));
      }).catch(() => undefined);
    }

    // Limpiar cache del navegador al cargar la aplicación
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    // Forzar recarga sin cache
    const handleBeforeUnload = () => {
      if (navigator?.serviceWorker) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((reg) => reg.unregister().catch(() => undefined));
        }).catch(() => undefined);
      }
      if ('caches' in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const clearCache = () => {
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }
  };

  const forceReload = () => {
    clearCache();
    window.location.reload();
  };

  return { clearCache, forceReload };
};
